import React from 'react';
import { Check } from 'lucide-react';
import { ImageInfo } from './ImageInfo';

interface FeaturedImageBoxProps {
  readonly imageUrl: string | undefined;
  readonly dimension?: string;
  readonly productKey: string;
  readonly onDrop: (e: React.DragEvent, productKey: string) => void;
  readonly onDragOver: (e: React.DragEvent) => void;
}

export const FeaturedImageBox: React.FC<FeaturedImageBoxProps> = ({
  imageUrl,
  dimension,
  productKey,
  onDrop,
  onDragOver,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'center' }}>
      <div
        onDrop={(e) => onDrop(e, productKey)}
        onDragOver={onDragOver}
        style={{
          width: '100%',
          paddingBottom: '100%',
          position: 'relative',
          border: '3px dashed #0d6efd',
          borderRadius: '8px',
          background: imageUrl ? 'white' : '#f8f9fa',
          overflow: 'hidden',
          cursor: 'default',
          transition: 'all 0.2s',
        }}
      >
        {imageUrl ? (
          <>
            <img
              src={imageUrl}
              alt="Featured"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
            <div
              className="position-absolute top-0 end-0 m-1"
              style={{
                background: '#28a745',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Check size={12} color="white" />
            </div>
          </>
        ) : (
          <div
            className="text-center text-muted"
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <small>Drop image here</small>
          </div>
        )}
      </div>
      <ImageInfo url={imageUrl} {...(dimension && { dimension })} />
    </div>
  );
};
